<template>
    <section v-if="couponList && couponList.length">
        <div class="touch-strip promotion-strip"  @click="changeShowCoupon">
            <a href="javascript:;">
                <div class="content">
                    <h3>领券</h3>
                    <ul class="detail-promotionList">
                        <li v-for="(coupon, index) in couponList" class="coupon" v-if="index < 3" :key="index">
                            {{coupon.translatedFaceValue}}
                        </li>
                    </ul>
                    <span class="more">{{couponList.length}}个</span>
                    <i class="arrow"></i>
                </div>
            </a>
        </div>
        <Popup :show="showCoupon" title="领取优惠券" class="coupon-popup">
            <coupon-inner :couponList="couponList" v-if="showCoupon.isShow" @openPackagePopup="openPackagePopup" @closeCouponPopup="closeCouponPopup"></coupon-inner>
        </Popup>
    </section>
</template>

<script>
import Popup from '@/components/Popup';
import CouponInner from '@/components/detail/coupon/CouponInner';
export default {
    name: 'coupon',
    data() {
        return {
            showCoupon: {isShow: false}
        }
    },
    props: {
        couponList: {
            type: Array,
            default: function () {
                return []
            }
        }
    },
    computed: {
    },
    methods: {
        changeShowCoupon() {
            this.showCoupon.isShow = true;
        },
        closeCouponPopup() {
            this.showCoupon.isShow = false;
        },
        openPackagePopup() {
            this.$emit('openPackagePopup');
        }
    },
    components: {
        Popup,
        CouponInner
    }
}
</script>
<style lang="scss">
.coupon-popup .pop-body {
    height: 400px;
    @supports (height: 50vh) {
        height: 50vh;
    }
    overflow: auto;
    -webkit-overflow-scrolling : touch;
}
</style>



// WEBPACK FOOTER //
// Coupon.vue